/* global GoogleAnalyticsTrackingID */

import init from './init';
import gaObjectName from './object-name';
import GTM from './google-tag-manager';

init(window.GoogleAnalyticsTrackingID || null, gaObjectName, window);
GTM(window, document, window.GoogleTagManagerIdentifier || null);
